// extracted by mini-css-extract-plugin
module.exports = {"container":"RefreshPage_container__3akrk","icon":"RefreshPage_icon__1iIUz"};